module.exports = __webpack_public_path__ + "img/date.0b498309.svg";